import { resolve } from '@/core/di';
import { AuthenticationApi } from './AuthenticationApi';

export const authenticationApi = (): AuthenticationApi => resolve(AuthenticationApi);
